import { render, staticRenderFns } from "./Island.vue?vue&type=template&id=58758dc5&scoped=true&"
import script from "./Island.vue?vue&type=script&lang=js&"
export * from "./Island.vue?vue&type=script&lang=js&"
import style0 from "./Island.vue?vue&type=style&index=0&id=58758dc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58758dc5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\soiko\\Documents\\Projects\\game\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58758dc5')) {
      api.createRecord('58758dc5', component.options)
    } else {
      api.reload('58758dc5', component.options)
    }
    module.hot.accept("./Island.vue?vue&type=template&id=58758dc5&scoped=true&", function () {
      api.rerender('58758dc5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Island.vue"
export default component.exports